import { Col, Row } from "antd";
import { useBannerContext } from "../../../context/BannerContext/BannerContext";
import { DefaultImageList } from "../../../context/BannerContext/constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { FileUploadItems } from "./constants";


const BannerEditInfo = () => {
	const { bannerDetail, setBannerForm } = useBannerContext();

	const handleFileChange = (files: FileData[] | null, key: string) => {
		if (files && files.length > 0) {
			setBannerForm(prevState => ({
				...prevState,
				[key]: files[0].file
			}));
		}
	};

	return (
		<>
			<Row gutter={20}>
				{FileUploadItems.map((item) => (
					<Col span={8} key={item.key}>
						<FileUploadComponent
							title={item.label}
							onChange={(fileData: FileData[] | null) => handleFileChange(fileData, item.key)}
							dimensions={item.dimensions}
							fileSize={item.fileSize}
							fileSizeText={item.fileSizeText}
							format={item.format}
							defaultValue={bannerDetail?.imageList[item.default as keyof DefaultImageList] as string}
						/>
					</Col>
				))}
			</Row>
		</>
	);
};

export default BannerEditInfo;
